module.exports = __webpack_public_path__ + "media/images/icons/v2/heart-5d855d453a70305f901ded876e712c62.svg";